import { render } from "./imprimirrecibocambiohabitacion.vue?vue&type=template&id=2be9963b&scoped=true"
import script from "./imprimirrecibocambiohabitacion.vue?vue&type=script&lang=js"
export * from "./imprimirrecibocambiohabitacion.vue?vue&type=script&lang=js"

import "./imprimirrecibocambiohabitacion.vue?vue&type=style&index=0&id=2be9963b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be9963b"]])

export default __exports__